import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { environment } from '@env/environment';
import {
  GInputGroupModule,
  GInputModule,
  GSelectModule
} from '@gotadi/design-system';
import {
  BASE_PATH2,
  BASE_PATH3,
  PviInsuranceInventoryResourceService,
  PviInsuranceResourceService
} from '@gtd/api-services/service-inventory';
import { CheckboxModule } from '@gtd/components/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { InsuranceConfirmationComponent } from './components/common/insurance-confirmation/insurance-confirmation.component';
import { InsuranceCustomersComponent } from './components/common/insurance-customers/insurance-customers.component';
import { InsuranceResultWidgetComponent } from './components/common/insurance-result/insurance-result-widget/insurance-result-widget.component';
import { InsuranceResultComponent } from './components/common/insurance-result/insurance-result.component';
import { InsuranceWidgetComponent } from './components/common/insurance-widget/insurance-widget.component';
import { DelayInsuranceComponent } from './components/flexi/delay-insurance/delay-insurance.component';
import { InsuranceComponent } from './components/insurance.component';
import { PviDialogComponent } from './components/pvi/pvi-dialog/pvi-dialog.component';
import { PviInsuranceComponent } from './components/pvi/pvi-insurance/pvi-insurance.component';
import { PviPaxFormComponent } from './components/pvi/pvi-pax-form/pvi-pax-form.component';
import { PviPlansComponent } from './components/pvi/pvi-plans/pvi-plans.component';
import { InsuranceService } from './services/insurance.service';
import { MatIconModule } from '@angular/material';
import { GroupByAgeRangePipe } from './pipes/group-by-age-name.pipe';
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatExpansionModule,
    MatDialogModule,
    MatButtonModule,
    CheckboxModule,
    GInputModule,
    GInputGroupModule,
    GSelectModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule
  ],
  declarations: [
    InsuranceComponent,
    InsuranceWidgetComponent,
    PviInsuranceComponent,
    DelayInsuranceComponent,
    PviDialogComponent,
    PviPaxFormComponent,
    InsuranceCustomersComponent,
    PviPlansComponent,
    InsuranceConfirmationComponent,
    InsuranceResultComponent,
    InsuranceResultWidgetComponent,
    GroupByAgeRangePipe
  ],
  providers: [
    PviInsuranceResourceService,
    PviInsuranceInventoryResourceService,
    InsuranceService,
    {
      provide: BASE_PATH3,
      useValue: environment.api.b2cClient
    },
    {
      provide: BASE_PATH2,
      useValue: environment.api.inventoryService
    }
  ],
  entryComponents: [PviDialogComponent],
  exports: [
    InsuranceComponent,
    PviDialogComponent,
    InsuranceResultComponent,
    InsuranceResultWidgetComponent,
    GroupByAgeRangePipe
  ]
})
export class InsuranceModule {}
